import { authenticated, unauthenticated } from './WebRequest';
import type {
  ApiThunk,
  LoginSiteUserResponse,
  Nullable,
  PasswordActionResponse,
  RemoveSiteUserResponse,
  ResetPasswordParams,
  SaveSiteUserInput,
  SendResetPasswordLinkParams,
  SiteUser,
  SiteUacResponse,
} from './types/User';

export type {
  ApiThunk,
  LoginSiteUserResponse,
  Nullable,
  PasswordActionResponse,
  RemoveSiteUserResponse,
  ResetPasswordParams,
  SaveSiteUserInput,
  SendResetPasswordLinkParams,
  SiteUacResponse,
  SiteUser,
  SiteUserGroup,
} from './types/User';

export function fetch_site_users(zoneid: number): ApiThunk<SiteUacResponse> {
  return authenticated.get<SiteUacResponse>(
    `/site_user/zone/${zoneid}/fetch_site_uac`
  );
}

export function login_site_user(
  zoneid: number,
  siteid: number,
  username?: Nullable<string>,
  password?: Nullable<string>,
  started_as_admin?: Nullable<boolean>
): ApiThunk<LoginSiteUserResponse> {
  return authenticated.post<LoginSiteUserResponse>(
    `/site_user/zone/${zoneid}/site/${siteid}/login_site_user_v2/`,
    { username, password, started_as_admin }
  );
}

/**
 *
 * @param zoneid currently in use zoneid
 * @param siteid currently in use siteid
 * @param user = {
 *   groups: [4294967292, 4294967293, 4294967294, 4294967295], // Groups which the user belongs to
 *   localuserid: 2, // Localuserid or null
 *   username: "joee",
 *   username: "pass",
 * }
 * @returns {function(): *}
 */
export function save_site_user(
  zoneid: number,
  siteid: number,
  user: SaveSiteUserInput
): ApiThunk<SiteUser> {
  return authenticated.post<SiteUser>(
    `/site_user/zone/${zoneid}/site/${siteid}/save_site_user/`,
    user
  );
}

/**
 *
 * @param siteid currently in use siteid
 * @param localuserid user to delete
 * @returns {function(): *}
 */
export function remove_site_user(
  siteid: number,
  localuserid: number
): ApiThunk<RemoveSiteUserResponse> {
  return authenticated.post<RemoveSiteUserResponse>(
    `/site_user/site/${siteid}/remove_site_user/`,
    {
      localuserid,
    }
  );
}

export function resetPassword(
  params: ResetPasswordParams
): ApiThunk<PasswordActionResponse> {
  return unauthenticated.post<PasswordActionResponse>(
    '/lost_password_reset',
    params
  );
}

export function sendResetPasswordLink(
  params: SendResetPasswordLinkParams
): ApiThunk<PasswordActionResponse> {
  return unauthenticated.post<PasswordActionResponse>(
    '/send_password_rest_link',
    params
  );
}
